/* @flow */

import * as React from 'react';

export type ModalStatusContextProps = {
  modals: Set<symbol>,
  register: (symbol) => void,
  unregister: (symbol) => void,
};

export default React.createContext<ModalStatusContextProps>({
  modals: new Set(),
  register: () => {},
  unregister: () => {},
});
